/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const RugsIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / rugs</title>
            <g fillRule="nonzero" fill="#FCA61B">
                <path d="M35 6v34H11V6h24zm1-1H10v36h26V5z" />
                <path d="M32 9v28H14V9h18zm1-1H13v30h20V8zM12 40v3h-2v-3zM18 40v3h-2v-3zM15 40v3h-2v-3zM21 40v3h-2v-3zM24 40v3h-2v-3zM27 40v3h-2v-3zM30 40v3h-2v-3zM33 40v3h-2v-3zM36 40v3h-2v-3zM12 3v3h-2V3zM18 3v3h-2V3zM15 3v3h-2V3zM21 3v3h-2V3zM24 3v3h-2V3zM27 3v3h-2V3zM30 3v3h-2V3zM33 3v3h-2V3zM36 3v3h-2V3z" />
                <path d="M23 13.044L17.57 23 23 32.956 28.43 23 23 13.044zm0 22L16.43 23 23 10.956 29.57 23 23 35.044z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Rugs.tsx